<template>
  <modal name="reference-modal" class="modal" adaptive scrollable width="1100" height="auto">
    <header class="modal__header">
      <button type="button" class="modal__close" @click="$modal.hide('reference-modal')">
        <icon class="modal__icon" name="close" width="59" height="59" />
      </button>
    </header>

    <div class="modal__body">
      <reference-item />
    </div>
  </modal>
</template>

<script>
import Icon from '../shared/Icon'
import ReferenceItem from './ReferenceItem'

export default {
  components: {
    Icon,
    ReferenceItem
  }
}
</script>

<style lang="scss" scoped>
.v--modal-overlay {
  background: rgba($white, .3);
}

.v--modal {
  border-radius: 0!important;
  box-shadow:  0 0 14px 0 rgba(0, 0, 0, .12);
}

.modal {
  &__header {
    text-align: right;
  }

  &__close {
    background: transparent;
    border: none;
    padding: 0;

    &:focus {
      outline: 0;
    }
  }

  &__icon {
    fill: $theme-red-100;
    transition: fill 250ms ease;

    :hover > & {
      fill: $theme-red-200;
    }
  }

  &__body {
    padding: 10px;

    @include media-breakpoint-up(md) {
      padding: 10px 104px 70px;
    }
  }
}
</style>
